import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { SessionProvider, useSession } from './session.tsx'
import { Spinner } from './components/ui.tsx'
import { AppLayout } from './components/AppLayout.tsx'
import { MainLayout } from './components/MainLayout.tsx'
import { LoginPage } from './pages/LoginPage.tsx'
import { InvitePage } from './pages/InvitePage.tsx'
import { ResetPasswordPage } from './pages/ResetPasswordPage.tsx'
import { TripsPage } from './pages/TripsPage.tsx'
import { TemplatePage } from './pages/TemplatePage.tsx'
import { TemplatesPage } from './pages/TemplatesPage.tsx'
import { GroupPage } from './pages/GroupPage.tsx'
import { OffersPage } from './pages/OffersPage.tsx'
import { SharePage } from './pages/SharePage.tsx'
import { StoresPage } from './pages/StoresPage.tsx'
import { TripScreen } from './pages/trip/TripScreen.tsx'

// Retezce v UI cte uzivatel, takze se pisou se spravnou diakritikou.
// Bez diakritiky jsou jen komentare a identifikatory.

export function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </SessionProvider>
  )
}

function Shell() {
  const { state } = useSession()

  if (state.status === 'loading') {
    return (
      <div className="splash">
        <Spinner label="Načítám…" />
      </div>
    )
  }

  // Jeden strom rout pro oba stavy: pozvanka a obnova hesla zustanou
  // namountovane i ve chvili, kdy se po registraci zmeni prihlaseni.
  return (
    <Routes>
      <Route path="/p/:token" element={<InvitePage />} />
      <Route path="/obnova/:token" element={<ResetPasswordPage />} />
      {state.status === 'signed-in' ? (
        <>
          <Route element={<AppLayout />}>
            <Route element={<MainLayout />}>
              <Route index element={<TripsPage />} />
              <Route path="sablony" element={<TemplatesPage />} />
              <Route path="sablony/:templateId" element={<TemplatePage />} />
              {/* Drivejsi jedina sablona — odkazy a zalozky na plose. */}
              <Route path="sablona" element={<Navigate to="/sablony" replace />} />
              <Route path="akce" element={<OffersPage />} />
              <Route path="skupina" element={<GroupPage />} />
            </Route>
            <Route path="/skupina/obchody" element={<StoresPage />} />
            <Route path="/sdilet" element={<SharePage />} />
            <Route path="/nakup/:tripId/*" element={<TripScreen />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <Route path="*" element={<LoginPage />} />
      )}
    </Routes>
  )
}
